/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'yes' }, { id: 'no' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-has-barber"
      progress={76}
      field="hairstyleHasBarber"
      setter="setHairstyleHasBarber"
      ns="hairstyleHasBarber"
      options={OPTIONS}
      hasSubtitle
    />
  );
}

export default Page;
